module.exports = __webpack_public_path__ + "static/media/omar_sweeney.b62bb2c3.pdf";